@if ((messages$ | async); as messages) {
  @if (messages.messages.length > 0) {
    <rask-icon
      #icon
      [icon]="messages.icon"
      ngClass="error-icon"
      popoverClass="popover-error popover-no-max-width">
      <div class="popover-message-container">
        @for (message of messages.messages; track $index) {
          <div class="popover-message">
            <span>{{ message.message }}</span>
          </div>
        }
      </div>
    </rask-icon>
  }
}